import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";


export const getNeighborhoodPinboardComment = createAsyncThunk("getNeighborhoodPinboardComment", async (pinboardId, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/neighbor_pinboard/${pinboardId}/comments/`)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            return rejectWithValue("No response from server");
        }
    }
});

export const createpinboardComment = createAsyncThunk("createpinboardComment", async ({ data, pinboardId }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_pinboard/${pinboardId}/comment/`, data)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            // The request was made but no response was received
            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});

export const updatepinboardComment = createAsyncThunk("updatepinboardComment", async ({ data, commentId },
    { rejectWithValue }) => {
    try {
        const response = await axiosInstance.put(`/neighbor_pinboard/comment/${commentId}/update/`, data)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            // The request was made but no response was received

            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});

export const deletepinboardComment = createAsyncThunk("deletepinboardComment", async ({ commentId },
    { rejectWithValue }) => {
    try {
        const response = await axiosInstance.delete(`/neighbor_pinboard/comment/${commentId}/delete/`)
        return commentId
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            return rejectWithValue("No response from server");
        }
        else {
            return rejectWithValue(error.message);
        }
    }
});

export const likePinboardComment = createAsyncThunk("likePinboardComment", async ({ commentId }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_pinboard/comment/${commentId}/like/`);
        const result = response.data;
        return { result, id: commentId }
    }
    catch (error) {
        console.error("Error:", error);
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

export const getNeighborhoodPinboardCommentReply = createAsyncThunk("getNeighborhoodPinboardCommentReply", async (commentId, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/neighbor_pinboard/comment/${commentId}/replies/`)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            return rejectWithValue("No response from server");
        }
    }
});
export const createpinboardCommentReply = createAsyncThunk("createpinboardCommentReply", async ({ data, commentId }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_pinboard/comment/${commentId}/reply/`, data)
        const result = response.data;
        return { result, comment_id: commentId }
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            // The request was made but no response was received
            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});
export const updatepinboardCommentReply = createAsyncThunk("updatepinboardCommentReply", async ({ data, replyId },
    { rejectWithValue }) => {
    try {
        const response = await axiosInstance.patch(`/neighbor_pinboard/reply/${replyId}/update/`, data)
        const result = response.data;
        return { data, replyId }
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            // The request was made but no response was received
            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});
export const deletepinboardCommentReply = createAsyncThunk("deletepinboardCommentReply", async ({ replyId },
    { rejectWithValue }) => {
    try {
        const response = await axiosInstance.delete(`/neighbor_pinboard/reply/${replyId}/delete/`)
        return replyId
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {

            return rejectWithValue("No response from server");
        }
        else {
            return rejectWithValue(error.message);
        }
    }
});

export const likeDislikePinboardCommentReply = createAsyncThunk("likeDislikePinboardCommentReply", async ({ replyId }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_pinboard/reply/${replyId}/like/`);
        const result = response.data;
        return { result, id: replyId }
    }
    catch (error) {
        console.error("Error:", error);
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});



export const NeighborhoodPinboardComment = createSlice({
    name: "pinboardComment",
    initialState: {
        pinboardComment: [],
        pinboardCommentReply: [],
        loading: false,
        replyLoading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder.addCase(getNeighborhoodPinboardComment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getNeighborhoodPinboardComment.fulfilled, (state, action) => {
            state.loading = false;
            state.pinboardComment = action.payload;
        });
        builder.addCase(getNeighborhoodPinboardComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(createpinboardComment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createpinboardComment.fulfilled, (state, action) => {
            state.loading = false;
            state.pinboardComment = [action.payload.comment, ...state.pinboardComment];
        });
        builder.addCase(createpinboardComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // updatepinboardComment
        builder.addCase(updatepinboardComment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(updatepinboardComment.fulfilled, (state, action) => {
            state.loading = false;
            const updatedComment = state.pinboardComment.map((comment) => {
                if (comment.id === action.payload.id) {
                    return {
                        ...comment,
                        ...action.payload,
                    };
                }
                return comment;
            });
            state.pinboardComment = updatedComment;
        });
        builder.addCase(updatepinboardComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // deletepinboardComment
        builder.addCase(deletepinboardComment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deletepinboardComment.fulfilled, (state, action) => {
            const result = state.pinboardComment?.filter((comment) => comment.id !== action.payload);
            state.pinboardComment = result;
            state.loading = false;
        });
        builder.addCase(deletepinboardComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // likePinboardComment
        builder.addCase(likePinboardComment.pending, (state) => {
            // state.loading = true;
        });
        builder.addCase(likePinboardComment.fulfilled, (state, action) => {
            state.loading = false;
            const updatedComment = state.pinboardComment.map((comment) => {
                if (comment.id === action.payload.id) {
                    return {
                        ...comment,
                        likes_count: action.payload.result.likes_count,
                        is_liked: action.payload.result.liked,

                    };
                }

                return comment;
            });
            state.pinboardComment = updatedComment;
        });
        builder.addCase(likePinboardComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // getNeighborhoodPinboardCommentReply
        builder.addCase(getNeighborhoodPinboardCommentReply.pending, (state) => {
            state.replyLoading = true;
        });
        builder.addCase(getNeighborhoodPinboardCommentReply.fulfilled, (state, action) => {
            state.replyLoading = false;
            state.pinboardCommentReply = action.payload;

        });
        builder.addCase(getNeighborhoodPinboardCommentReply.rejected, (state, action) => {
            state.replyLoading = false;
            state.error = action.payload;
        });

        /// createpinboardCommentReply
        builder.addCase(createpinboardCommentReply.pending, (state) => {
            state.replyLoading = true;
        });
        builder.addCase(createpinboardCommentReply.fulfilled, (state, action) => {
            state.loading = false;
            state.pinboardCommentReply = [action.payload.result, ...state.pinboardCommentReply];
        })
        builder.addCase(createpinboardCommentReply.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
        );

        // updatepinboardCommentReply
        builder.addCase(updatepinboardCommentReply.fulfilled, (state, action) => {
            state.loading = false;

            const updatedReply = state.pinboardCommentReply.map((reply) => {
                if (reply.id === action.payload.replyId) {
                    return {
                        ...reply,
                        ...action.payload.data,
                    };
                }
                return reply;
            }
            );
            state.pinboardCommentReply = updatedReply;
        });

        //deletepinboardCommentReply
        builder.addCase(deletepinboardCommentReply.pending, (state) => {
            // state.loading = true;
        });
        builder.addCase(deletepinboardCommentReply.fulfilled, (state, action) => {
            state.loading = false;
            state.pinboardCommentReply = state.pinboardCommentReply.filter((reply) => reply.id !== action.payload);
        });
        builder.addCase(deletepinboardCommentReply.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
        );


        // likeDislikePinboardCommentReply
        builder.addCase(likeDislikePinboardCommentReply.pending, (state) => {
            // state.loading = true;
        });
        builder.addCase(likeDislikePinboardCommentReply.fulfilled, (state, action) => {
            state.loading = false;
            const updatedReply = state.pinboardCommentReply.map((reply) => {
                if (reply.id === action.payload.id) {
                    return {
                        ...reply,
                        likes_count: action.payload.result.likes_count,
                        is_liked: action.payload.result.liked,

                    };
                }
                return reply;
            }
            );
            state.pinboardCommentReply = updatedReply;
        })
        builder.addCase(likeDislikePinboardCommentReply.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

    },
});

export default NeighborhoodPinboardComment.reducer;